const axios = require("axios");
const MockAdapter = require("axios-mock-adapter");
const { successResponse, failureResponse } = require("./utils");
const api = require("./api");

module.exports = ({ baseURL, timeout = 5000 }) => {
  const client = axios.create({ baseURL });

  // Client Configuration.
  client.interceptors.response.use(successResponse, failureResponse);
  client.defaults.timeout = timeout;

  const mock = new MockAdapter(client, {
    delayResponse: 500,
  });

  mock.onGet("/order/abc").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      order_id: "abc",
      order_status: "paid",
    },
  });

  mock.onPost("/order/create").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      order_id: "abc",
      order_status: "pending",
      order_currency: "eur",
      order_amount: 1000,
    },
  });

  mock.onPost("/order/abc/pay").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      order_id: "abc",
      order_status: "paid",
    },
  });

  mock.onPost("/auth/login").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      id: "123",
      token: "abc",
      role: "customer",
    },
  });

  mock.onPost("/auth/logout").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {},
  });

  mock.onPost("/auth/verify").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      token: "abc",
    },
  });

  mock.onGet("/user/profile/123").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      customer_currency: "EUR",
      customer_delivery_address: {
        default: {
          city: "Villingen-Schwenningen",
          country: "DE",
          street: "Heinrich-Hertz-Str. 27",
          zip: "78052",
        },
      },
      customer_email: "info@opticunion.de",
      customer_invoice_address: {
        city: "Villingen-Schwenningen",
        country: "DE",
        street: "Heinrich-Hertz-Str. 27",
        zip: "78052",
      },
      customer_language: "D",
      customer_name: "Opticunion GmbH",
      customer_number: "19999",
      customer_payment_constraint: "prepay",
      customer_price_list: "default",
      customer_tax_id: null,
      customer_country: "DE",
    },
  });

  mock.onPost("cart/items/add").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      id: "1234",
      items: [
        {
          articleID: "86.164.01",
          brand: "Opticunion Basis",
          qty: 11,
          price: "9,99",
        },
        {
          articleID: "86.173.04",
          brand: "Opticunion Basis",
          qty: 12,
          price: "9,99",
        },
        {
          articleID: "85.175.02",
          brand: "Opticunion Basis",
          qty: 13,
          price: "9,99",
        },
        {
          articleID: "85.273.03",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
        {
          articleID: "81.175.09",
          brand: "Opticunion Basis",
          qty: 13,
          price: "9,99",
        },
        {
          articleID: "82.273.09",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
      ],
      metadata: {
        customer_id: "abc",
        customer_price_list: 1,
        customer_tax_id: null,
      },
      summary: {
        items_count: 4,
        customer_currency: "eur",
        subtotal: "130,00",
        shipping: {
          shipping_method: "DPD",
          shipping_rate: "4,99",
        },
        tax: "3,99",
        total: "149,99",
      },
    },
  });

  mock.onPost("cart/items/update").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      id: "1234",
      items: [
        {
          articleID: "86.164.01",
          brand: "Opticunion Basis",
          qty: 11,
          price: "9,99",
        },
        {
          articleID: "86.173.04",
          brand: "Opticunion Basis",
          qty: 12,
          price: "9,99",
        },
        {
          articleID: "85.175.02",
          brand: "Opticunion Basis",
          qty: 13,
          price: "9,99",
        },
        {
          articleID: "85.273.03",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
      ],
      metadata: {
        customer_id: "abc",
        customer_price_list: 1,
        customer_tax_id: null,
      },
      summary: {
        items_count: 4,
        customer_currency: "eur",
        subtotal: "130,00",
        shipping: {
          shipping_method: "DPD",
          shipping_rate: "4,99",
        },
        tax: "3,99",
        total: "149,99",
      },
    },
  });

  mock.onGet("/user/cart/123").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      id: "1234",
      items: [
        {
          articleID: "111",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
        {
          articleID: "112",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
        {
          articleID: "113",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
        {
          articleID: "114",
          brand: "Opticunion Basis",
          qty: 10,
          price: "9,99",
        },
      ],
      metadata: {
        customer_id: "abc",
        customer_price_list: 1,
        customer_tax_id: null,
      },
      summary: {
        items_count: 4,
        customer_currency: "eur",
        subtotal: "130,00",
        shipping: {
          shipping_method: "DPD",
          shipping_rate: "4,99",
        },
        tax: "3,99",
        total: "149,99",
      },
    },
  });

  mock.onPost("/cart/items/delete").reply(200, {
    statusCode: 200,
    message: "ok",
    data: {
      id: "1234",
      items: [
        {
          articleID: "86.164.01",
          brand: "Opticunion Basis",
          qty: 11,
          price: "9,99",
        },
        {
          articleID: "86.173.04",
          brand: "Opticunion Basis",
          qty: 12,
          price: "9,99",
        },
        {
          articleID: "85.175.02",
          brand: "Opticunion Basis",
          qty: 13,
          price: "9,99",
        },
      ],
      metadata: {
        customer_id: "abc",
        customer_price_list: 1,
        customer_tax_id: null,
      },
      summary: {
        items_count: 4,
        customer_currency: "eur",
        subtotal: "120,00",
        shipping: {
          shipping_method: "DPD",
          shipping_rate: "4,99",
        },
        tax: "3,99",
        total: "119,99",
      },
    },
  });

  return api(client);
};



// WEBPACK FOOTER //
// ../shared/optilit-http-client/src/client.mock.js